import React from 'react';
import PropTypes from 'prop-types';

const extensionMap = {
  doc: ['docx', 'doc'],
  pdf: ['pdf'],
};

const ResumeViewer = ({ resumeUrl }) => {
  const urlParts = resumeUrl.split('.');
  const lastExtension = urlParts[urlParts.length - 1];

  if (extensionMap.doc.includes(lastExtension)) {
    return (
      <iframe
        title="doc"
        className="doc"
        style={{
          width: '100%',
          height: 800,
          borderRadius: '5px',
        }}
        src={`https://docs.google.com/gview?url=${resumeUrl}&embedded=true`}
      />
    );
  }
  if (extensionMap.pdf.includes(lastExtension)) {
    return (
      <object
        style={{ borderRadius: '5px' }}
        data={`${resumeUrl}`}
        width="100%"
        height="800"
        aria-label="resume"
      />
    );
  }
  return null;
};
export default ResumeViewer;

ResumeViewer.propTypes = {
  resumeUrl: PropTypes.string.isRequired,
};
